import React from "react";

const Pricing = ({folioContrato = ''}) => {
  return (
    <div className="container-fluid bg-transparent py-0">

      {/* <p className="text-secondary text-center fs-4">
        ¡No esperes más!
      </p>

      <h2 className="text-center fw-semibold mb-5 mt-3">
        Adquiere tu licencia{" "}
        <span className="fw-bold fs-3">
          Click<span className="text-warning">+</span>
        </span>{" "}
        Academy
      </h2> */}

      <div className="row justify-content-center g-4" style={{ maxWidth: "900px", margin: "0 auto" }}>

        {/* PLAN MENSUAL */}
        <div
          className="col-12 col-md-6"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <div className="h-100 p-4 rounded border border-secondary bg-dark bg-opacity-45">

            <h3 className="text-white fw-semibold mb-4">Mensual</h3>

            <div className="mb-3">
              <span className="fs-3 fw-bold text-white">$149.00/mes</span>
            </div>

            <ul className="list-unstyled text-light mb-4">
              {[
                "Acceso a 7 cursos de Office 365",
                "1 curso de regalo por 6 meses",
                "Certificado por cada curso",
                "Cursos 100% interactivos",
                "Acceso a herramientas de IA",
                "Manejo de Copilot",
                "Asesorías personalizadas (Aplican restricciones)",
                "Preparación para la certificación MOS",
              ].map((item, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mb-2">
                  <span style={{color: "#4ace66"}}>✔</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <form
              action={`${window.location.origin}/api/suscripciones/stripe/create-checkout-session`}
              method="POST"
            >
              <input type="hidden" name="lookup_key" value="click+_mensual" />
              <button className="btn btn-light w-100">
                Elegir plan
              </button>
            </form>

          </div>
        </div>

        {/* PLAN ANUAL */}
        <div
          className="col-12 col-md-6"
          data-aos="fade-up"
          data-aos-delay="500"
          data-aos-duration="800"
        >
          <div
            className="h-100 p-5 rounded shadow text-white"
            style={{
              background: "linear-gradient(135deg, #ff9900, #212529)",
            }}
          >
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start mb-4 gap-3">
              <h3 className="fw-semibold">Anual</h3>
              <span className="badge bg-dark bg-opacity-50 text-uppercase">
                Mejor precio
              </span>
            </div>

            <div className="mb-3">
              <span className="fs-3 fw-bold">$1499.00/año</span>
              <p className=" fs-5 mb-0" style={{color: "#61c577"}}>Ahorras un 20%</p>
            </div>

            <ul className="list-unstyled mb-4">
              {[
                "Acceso a 7 cursos de Office 365",
                "1 curso de regalo por 6 meses",
                "Certificado por cada curso",
                "Cursos 100% interactivos",
                "Acceso a herramientas de IA",
                "Manejo de Copilot",
                "Asesorías personalizadas (Aplican restricciones)",
                "Preparación para la certificación MOS",
              ].map((item, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mb-2">
                  <span style={{color: "#61c577"}}>✔</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <form
              action={`${window.location.origin}/api/suscripciones/stripe/create-checkout-session`}
              method="POST"
            >
              <input type="hidden" name="lookup_key" value="click+_anual" />
              <input type="hidden" name="folioContrato" value={`${folioContrato}`} />

              <button className="btn btn-light w-100">
                Elegir plan
              </button>
            </form>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Pricing;
